/**
 * A list of valid deployment server environments
 */
export enum ServerEnvironment {
    DEMO = 'DEMO',
    SANDBOX = 'SANDBOX',
    STAGE = 'STAGE',
    UAT = 'UAT',
    CN_UAT = 'CN_UAT',
    DHL_UAT = 'DHL_UAT',
    SES = 'SES',
    SYDNEY = 'SYDNEY',
    CANADA = 'CANADA',
    FRANKFURT = 'FRANKFURT',
    IRELAND = 'IRELAND',
    TOKYO = 'TOKYO',
    SAO_PAULO = 'SAO_PAULO',
    SINGAPORE = 'SINGAPORE',
    UK = 'UK',
    MENA = 'MENA',
    PRODUCTION = 'PRODUCTION',
    DEVELOPMENT = 'DEVELOPMENT'
}

/**
 * A list of valid CI server environments
 */
export enum ServerCIEnvironment {
    ANY = 'ANY',
    DEMO = 'Demo',
    DEVELOPMENT = 'Development',
    PRODUCTION = 'Production',
    SANDBOX = 'Sandbox',
    SES = 'SES',
    STAGE = 'Stage',
    UAT = 'UAT',
    CN_UAT = 'workload-cn-uat-account',
    DHL_UAT = 'workload-dhl-account'
}

/**
 * Describes the struture of a `ServerBaseUrl` object
 */
export interface ServerBaseUrl {
    /**
     * The base url to use for all Wise API calls
     */
    apiServer: string;
    /**
     * The base url to use for all Aurora API calls
     */
    auroraApiServer: string;

    /**
     * The base url to use for all Wise Socket calls
     */
    socketServer: string;
    auroraServer: string;

    /**
     * The corresponding Gitlab environment name
     */
    CIEnv: ServerCIEnvironment;

    /**
     * The base url to use for all Initial-vs-Actual (IvA) microservice calls
     */
    initialVsActualServer?: string;

    /**
     * The base url to use for all Equipment microservice calls
     */
    equipment?: string;

    /**
     * The base url to use for all Equipment socket calls
     */
    equipmentSocketServer?: string;

    /**
     * The deployment environment
     */
    environment?: ServerEnvironment;

    /**
     * The base url to use for all Vehicle profile microservice calls
     */
    vehicleProfile?: string;

    /**
     * The base url to use for all Route Path Geometry microservice calls
     */
    routePathGeometryServer?: string;

    /**
     * The base url to use for all Configurable Workflow microservice calls
     */
    configurableWorkflowServer?: string;

    /**
     * The base url to use for all Driver Cost service calls
     */
    driverCostServer?: string;

    /**
     * The base url to use for all Banner microservice calls
     */
    bannerService?: string;
}

/**
 * A list of valid `ServerBaseUrl` properties / keys
 */
export enum ServerBaseUrlKey {
    /**
     * The `ServerBaseUrl` property/key identifying the Wise API base url
     */
    API = 'apiServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Wise API base url
     */
    AURORA_API = 'auroraApiServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Wise Socket base url
     */
    SOCKET = 'socketServer',
    AURORA = 'auroraServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Initial-vs-Actual (IvA) microservice base url
     */
    IVA = 'initialVsActualServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Equipment microservice base url
     */
    EQUIPMENT = 'equipment',

    /**
     * The `ServerBaseUrl` property/key identifying the Equipment socket base url
     */
    EQUIPMENT_SOCKET = 'equipmentSocketServer',

    /**
     * The `ServerBaseUrl` property/key identifying the deployment environment
     */
    ENVIRONMENT = 'environment',

    /**
     * The `ServerBaseUrl` property/key identifying the CI environment
     */
    CI_ENVIRONMENT = 'CIEnv',

    /**
     * The `ServerBaseUrl` property/key identifying the Vehicle profile microservice base url
     */
    VEHICLE_PROFILE = 'vehicleProfile',

    /**
     * The `ServerBaseUrl` property/key identifying the Route path geometry microservice base url
     */
    ROUTE_PATH_GEOMETRY = 'routePathGeometryServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Configurable workflow microservice base url
     */
    CONFIGURABLE_WORKFLOW = 'configurableWorkflowServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Driver Cost service base url
     */
    DRIVER_COST = 'driverCostServer',

    /**
     * The `ServerBaseUrl` property/key identifying the Banner microservice base url
     */
    BANNER_SERVICE = 'bannerService'
}
